import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

const NotificationListItems = ({ ...props }) => {
  const { onClickHandler, notificationData, actionType = null } = props;
  let iconClass;
  switch (actionType) {
    case 0: case 7: case null:
      iconClass = 'icon-calendar';
      break;
    default:
      iconClass = 'icon-tasks';
      break;
  }

  return (
    <div className='notification-row' onClick={() => onClickHandler(notificationData)}>
      <div className='icon-container'>
        <i className={iconClass} />
      </div>
      <div className='notification-details'>
        {props.message}
      </div>
    </div>
  );
};

NotificationListItems.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
  id: PropTypes.number,
  actionType: PropTypes.number,
  time: PropTypes.string,
  message: PropTypes.string,
  notificationData: PropTypes.object
};

export default connect((state) => { return {}; })(withRouter(NotificationListItems));
